<ng-container>
	<base-display [smallLetters]="" [bigLetters]="getWaterPressure()" [unit]="'STD_UNIT_BAR_NORMAL_LEFT'" [scaleValue]="scaleValue()" [showScale]="true" [scaleType]="'pressure'"></base-display>
</ng-container>